import { render } from "./UploadForm.vue?vue&type=template&id=4ee6fc98"
import script from "./UploadForm.vue?vue&type=script&lang=js"
export * from "./UploadForm.vue?vue&type=script&lang=js"

import "./UploadForm.vue?vue&type=style&index=0&id=4ee6fc98&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__